export default {
  language: 'hu'
}



// WEBPACK FOOTER //
// ./src/config/base.js